import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { initializeApiClient } from './services/apiClient';

// Pages
import QueryPage from './pages/QueryPage';
import ReportsPage from './pages/ReportsPage';
import LoginPage from './pages/LoginPage';

// Layout
import Layout from './components/Layout';

interface AppProps {
  msalInstance: IPublicClientApplication;
}

function App({ msalInstance }: AppProps) {
  useEffect(() => {
    // Initialize API client with MSAL instance
    initializeApiClient(msalInstance);
  }, [msalInstance]);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <AuthenticatedTemplate>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/query" replace />} />
              <Route path="/query" element={<QueryPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="*" element={<Navigate to="/query" replace />} />
            </Routes>
          </Layout>
        </AuthenticatedTemplate>
        
        <UnauthenticatedTemplate>
          <Routes>
            <Route path="*" element={<LoginPage />} />
          </Routes>
        </UnauthenticatedTemplate>
      </Router>
    </MsalProvider>
  );
}

export default App;
